import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { Container, Tabs, Tab, Form, Button, Alert, Spinner, Row, Col, Breadcrumb  } from 'react-bootstrap';

import subBannerImg from '../assets/images/sub-banner-img.png';

const LoginPage = () => {
    const { t } = useTranslation();

    // State for tabs and forms
    const [activeTab, setActiveTab] = useState('password');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [mobileNo, setMobileNo] = useState('');
    const [otp, setOtp] = useState('');
    const [isOtpSent, setIsOtpSent] = useState(false);

    // State for UI feedback
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [otpMessage, setOtpMessage] = useState('');
    
    const title="Login"; 
    const breadcrumb="Login";

    const handleTabSelect = (key) => {
        setActiveTab(key);
        // Reset all fields and messages when switching tabs
        setEmail('');
        setPassword('');
        setMobileNo('');
        setOtp('');
        setIsOtpSent(false);
        setError('');
        setOtpMessage('');
    };

    const handlePasswordLogin = (e) => {
        e.preventDefault();
        setLoading(true);
        setError('');
        console.log('Logging in with:', { email, password });
        // Simulate API call
        setTimeout(() => {
            if (email === "test@example.com" && password === "password") {
                alert('Password Login Successful!');
            } else {
                setError(t('login_error_invalid_credentials'));
            }
            setLoading(false);
        }, 1500);
    };

    const handleRequestOtp = (e) => {
        e.preventDefault();
        setLoading(true);
        setOtpMessage('');
        console.log('Requesting OTP for:', mobileNo);
        // Simulate API call
        setTimeout(() => {
            if (mobileNo.match(/^\d{10}$/)) { // Simple 10-digit validation
                setOtpMessage(t('login_otp_sent_success'));
                setIsOtpSent(true);
            } else {
                setOtpMessage(t('login_error_invalid_mobile'));
            }
            setLoading(false);
        }, 1500);
    };

    const handleOtpLogin = (e) => {
        e.preventDefault();
        setLoading(true);
        setOtpMessage('');
        console.log('Verifying OTP:', otp);
        // Simulate API call
        setTimeout(() => {
            if (otp === "123456") {
                alert('OTP Login Successful!');
            } else {
                setOtpMessage(t('login_error_invalid_otp'));
            }
            setLoading(false);
        }, 1500);
    };

    return (
        <section className="float-left w-100 sub-banner-con login-sub-banner position-relative main-box">
            <Container>
                <Row className="align-items-center">
                <Col lg={7} md={7}>
                    <div className="sub-banner-content-con">
                    <h1>{t(title)}</h1>
                    <p dangerouslySetInnerHTML={{ __html: t(`${breadcrumb}_subtitle`) }}></p>
                    <div className="breadcrumb-con d-inline-block">
                        <Breadcrumb>
                        <Breadcrumb.Item linkAs={Link} linkProps={{ to: "/" }}>{t('nav_home')}</Breadcrumb.Item>
                        <Breadcrumb.Item active>{t(breadcrumb)}</Breadcrumb.Item>
                        </Breadcrumb>
                    </div>
                    </div>
                </Col>
                <Col lg={5} md={5}>
                    <div className="login-form-wrapper" >
                        <Tabs activeKey={activeTab} onSelect={handleTabSelect} id="login-methods-tabs" className="mb-3 login-tabs" justify>
                            <Tab eventKey="password" title={t('login_tab_password')}>
                                {error && <Alert variant="danger" className="py-2 small mt-2">{error}</Alert>}
                                <Form onSubmit={handlePasswordLogin} className="mt-4">
                                    <Form.Group className="mb-3" controlId="loginEmail">
                                        <Form.Control type="email" placeholder={t('login_email_placeholder')} value={email} onChange={(e) => setEmail(e.target.value)} required className="form-ctrl-login-custom" />
                                    </Form.Group>
                                    <Form.Group className="mb-2" controlId="loginPassword">
                                        <Form.Control type="password" placeholder={t('login_password_placeholder')} value={password} onChange={(e) => setPassword(e.target.value)} required className="form-ctrl-login-custom" />
                                    </Form.Group>
                                    <div className="d-flex justify-content-start mb-4">
                                        <Link to="/" className="custom-color-white-login small">{t('login_forgot_password')}</Link>
                                    </div>
                                    <Button variant="primary" type="submit" className="w-100 btn-lg text-uppercase" disabled={loading}>
                                        {loading && activeTab === 'password' ? <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" /> : t('login_btn_text')}
                                    </Button>
                                </Form>
                            </Tab>
                            <Tab eventKey="otp" title={t('login_tab_otp')}>
                                {otpMessage && <Alert variant={otpMessage.includes("Failed") || otpMessage.includes("Invalid") ? "danger" : "success"} className="py-2 small mt-2">{otpMessage}</Alert>}
                                {!isOtpSent ? (
                                    <Form onSubmit={handleRequestOtp} className="mt-4">
                                        <Form.Group className="mb-3" controlId="loginMobileNo">
                                            <Form.Control type="tel" placeholder={t('login_mobile_placeholder')} value={mobileNo} onChange={(e) => setMobileNo(e.target.value)} required className="form-ctrl-login-custom" />
                                        </Form.Group>
                                        <Button variant="primary" type="submit" className="w-100 btn-lg text-uppercase" disabled={loading}>
                                            {loading && activeTab === 'otp' && !isOtpSent ? <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" /> : t('login_get_otp_btn')}
                                        </Button>
                                    </Form>
                                ) : (
                                    <Form onSubmit={handleOtpLogin} className="mt-4">
                                        <Form.Group className="mb-3" controlId="loginOtp">
                                            <Form.Control type="text" placeholder="------" value={otp} onChange={(e) => setOtp(e.target.value.replace(/\D/g, '').slice(0, 6))} minLength="6" maxLength="6" required className="form-ctrl-login-custom text-center" style={{ letterSpacing: '0.5em' }} />
                                        </Form.Group>
                                        <Button variant="primary" type="submit" className="w-100 btn-lg text-uppercase" disabled={loading}>
                                            {loading && activeTab === 'otp' && isOtpSent ? <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" /> : t('login_with_otp_btn')}
                                        </Button>
                                        <Button variant="link" size="sm" onClick={() => { setIsOtpSent(false); setOtpMessage(''); }} className="d-block mx-auto mt-2 custom-color-white-login">
                                            {t('login_resend_otp')}
                                        </Button>
                                    </Form>
                                )}
                            </Tab>
                        </Tabs>
                        <div className="text-center mt-4">
                            <p className="small custom-color-white-login mb-2">{t('login_no_account')}</p>
                            <Link to="/register" className="btn btn-primary-link w-100 text-uppercase">
                                {t('login_register_now')}
                            </Link>
                        </div>
                    </div>
                </Col>
                </Row>
            </Container>
        </section>
    );
};

export default LoginPage;